export default function KpiCard({ label, value, icon, color = 'var(--primary)', trend, sublabel, onClick }) {
  return (
    <div
      className="card animate-fade"
      style={{ overflow: 'hidden', position: 'relative', cursor: onClick ? 'pointer' : undefined, transition: 'transform 0.15s, box-shadow 0.15s', userSelect: 'none' }}
      onClick={onClick}
      onMouseEnter={onClick ? e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 10px 28px rgba(0,0,0,0.12)'; } : undefined}
      onMouseLeave={onClick ? e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; } : undefined}
    >
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: color, borderRadius: '12px 12px 0 0' }} />
      <div className="card-body" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
        <div style={{ flex: 1 }}>
          <p style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 8 }}>
            {label}
          </p>
          <p style={{ fontSize: 28, fontWeight: 800, color: 'var(--text-primary)', lineHeight: 1 }}>{value}</p>
          {sublabel && <p style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 6 }}>{sublabel}</p>}
          {trend !== undefined && (
            <p style={{ fontSize: 12, fontWeight: 600, color: trend >= 0 ? 'var(--success)' : 'var(--danger)', marginTop: 6 }}>
              {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}% ce mois
            </p>
          )}
          {onClick && (
            <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 8 }}>Voir le détail →</p>
          )}
        </div>
        <div style={{
          width: 48, height: 48, borderRadius: 'var(--radius-md)',
          background: color + '18', display: 'flex', alignItems: 'center',
          justifyContent: 'center', fontSize: 22, flexShrink: 0
        }}>
          {icon}
        </div>
      </div>
    </div>
  );
}
